





































































































































































































































































































































































































































/* tslint:disable */
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SelectOption, SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import {
  SwTextfield,
  SwTextarea,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { DropdownLight } from '@/shared/dropdown-light';
import {
  SwTabGroup,
  SwTabPage,
} from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { Prop, Watch } from 'vue-property-decorator';
import uuifComponent from '@/shared/uuifComponent';
import _ from 'lodash';
import { IconConfig, SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { InfoState } from '@/core';
import { envCongif } from '@/shared/env.config';

const cssPrefix = 'idp-configdetail';
@Component({
  components: {
    ...uuifComponent,
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    DropdownLight,
    SwTabGroup,
    SwTabPage,
    SwToggle,
    SwSpinningProgress,
    SwCheckbox,
    SwTextarea,
    SwIcon,
  },
})
export default class IdpConfigdetailDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  closeDialog() {
    this.$emit('close-modal');
  }
  imgURL: string = '';
  oktaImgURL = '@/assets/images/okta.svg';
  azureImgURL = '@/assets/images/azure.svg';
  oktaHelpURL =
    'https://help.okta.com/en/prod/Content/Topics/Apps/Apps_App_Integration_Wizard.htm';
  azureHelpURL = 'https://docs.microsoft.com/en-us/azure/active-directory/';
  currentHelpURL = '';
  idpOrganization: any = '';
  idpFormGroupAlt: any;
  metadataURLResponseMessage: string = '';
  clientandsecretOn: boolean = true;
  spinnerInline: boolean = false;
  isReadOnly: boolean = false;

  showIdpDetailDialog: boolean = false;

  disableMetadataURL: boolean = false;
  disableOIDC: boolean = false;
  disableOIDCAuthType: boolean = false;
  iconConfig: IconConfig = {
    name: 'view',
  };
  disableSAML: boolean = false;

  // tslint:disable-next-line:max-line-length
  public pL: string =
    'A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC'; // Full-width char range for CJK \uFF00-\uFFEF
  public url: string = `([${this.pL}0-9._-]+\\.)+([${this.pL}0-9.-]{2,4}$)?`;
  urlValidator = new RegExp(this.url);
  imageSrc: string = '';
  @Prop()
  // infoIcon: any;
  @Prop()
  redirectURL: any;
  @Prop()
  choiceOfIDP: any;
  @Prop()
  idpChosen: any;

  myGlobal: any;
  idpFormGroup: any;
  //   protocols: string[] = ['SAML', 'Open ID Connect'];
  protocols: SelectOption[] = [
    {
      id: 'SAML',
      label: 'SAML',
    },
    {
      id: 'OIDC',
      label: 'Open ID Connect',
    },
  ];
  protocol: string = '';
  authorizationTypes: SelectOption[] = [
    {
      id: 'Code',
      label: 'Code',
    },
    {
      id: 'Token',
      label: 'Token',
    },
  ];
  authorizationType: string = '';
  cTAG = 'NWA:: ';
  accessToMetadata = false;
  spinner = false;
  metadataURLText: string = '';
  timeout = null;
  timeout2 = null;
  metadataNotValid = false;
  helpURLReference: any = '';
  height = 500;
  metadataURL: string = '';
  ssoURL: string = '';
  x509Certificate: string = '';
  authURL: string = '';
  introURL: string = '';
  clientID: string = '';
  clientSecret: string = '';
  isSubmitted: boolean = false;
  inValidMetadataURL: boolean = false;
  allEmployees: boolean = false;
  showEmpIdpToggle = false;
  disableAllEmployeeToggle = false;
  idpStatus: boolean = false;
  appliancePassword: any = '';
  type: any = 'password';
  infoIcon: boolean = false;
  assertionUrl: any = `${envCongif.api_url}/extauth`;
  samlRedirectUrl: any = `${envCongif.api_url}/extauth`;
  oidcRedirectUrl: any = `${window.location.origin}/muir/login`;

  @Watch('choiceOfIDP')
  choiceOfIDPChange() {
    this.chooseIDP(this.choiceOfIDP);
  }

  created() {
    console.warn(
      this.redirectURL,
      this.cTAG,
      this.redirectURL['infoIcon'],
      this.redirectURL['isReadOnly'],
      Object.keys(this.redirectURL),
      this.infoIcon,
    );

    this.chooseIDP(this.choiceOfIDP);
    this.isReadOnly = this.redirectURL['isReadOnly'];
    this.idpStatus = this.redirectURL['idpStatus'];
    this.appliancePassword = this.redirectURL['appliancePassword'];
    this.infoIcon = this.redirectURL['infoIcon'];
    this.height = this.isReadOnly ? 0 : 500;

    if (this.infoIcon) {
      this.chooseMode('editRegistry');
      // this.$emit('toggleInfoIconValue');
      // this.toggleInfoIconValue.emit();
    }
    this.disableMetadataURL = true;
    this.disableOIDC = true;
    this.disableOIDCAuthType = true;
    this.protocol = 'SAML';
    this.authorizationType = 'Code';
  }

  copyToClipboard() {
    const textarea = document.createElement('textarea') as HTMLTextAreaElement;
    textarea.style.height = '0px';
    textarea.style.opacity = '0';
    textarea.style.width = '0px';
    document.body.appendChild(textarea);
    textarea.value = this.appliancePassword;
    textarea.select();
    document.execCommand('copy');
    textarea!.parentNode!.removeChild(textarea);
    const message: InfoState = {
      infoMsg: this.$t('products.maintainceKey.copied')
      .toString(),
      infoType: 'success',
    };
    this.$store.commit('enqueueMessage', message);
  }

  refreshPassword() {
    this.$store.dispatch('SnbProfileStoreModule/refreshPassword').then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.appliancePassword = resp.newpwd;
      }
    });
  }

  showClientSecret() {
    console.warn((this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByTagName('input')[0]);
    (this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'text');
  }

  metatUrlValid() {
    if (this.metadataURL.match(this.urlValidator) && this.metadataURL !== '') {
      this.inValidMetadataURL = false;
      return true;
    } else {
      this.inValidMetadataURL = true;
      this.spinnerInline = false;
      return false;
    }
  }

  get getMetadataURLDebounceCalls() {
    return _.debounce(() => {
      this.metadataURL.indexOf('openid-configuration') < 0
        ? this.changeProtocol('SAML')
        : this.changeProtocol('OIDC');
      if (this.metatUrlValid() && !this.disableSAML) {
        this.chooseMode('handshake');
      }
      this.metadataURL.indexOf('okta.com') >= 0
        ? (this.imgURL = this.oktaImgURL)
        : (this.imgURL = this.azureImgURL);
      this.imageSrc = this.imgURL;
      this.accessToMedataCheck();
      this.spinnerInline = false;
    }, 1000);
  }

  onMetadataKeyUp() {
    this.isSubmitted = true;
    this.spinnerInline = true;
    this.getMetadataURLDebounceCalls();
  }

  validateClientSecretId() {
    if (
      this.metadataURL.match(this.urlValidator) &&
      this.metadataURL !== '' &&
      this.clientID !== '' &&
      this.clientSecret !== ''
    ) {
      this.clientandsecretOn = false;
      return true;
    } else {
      this.clientandsecretOn = true;
      this.spinnerInline = false;
      return false;
    }
  }

  get getClientSecretIdDebounceCalls() {
    return _.debounce(() => {
      if (this.validateClientSecretId()) {
        this.chooseMode('handshake');
      }
      this.spinnerInline = false;
    }, 1000);
  }

  onClientSecretIdKeyUp() {
    this.isSubmitted = true;
    this.spinnerInline = true;
    if (this.accessToMetadata) {
      this.getClientSecretIdDebounceCalls();
    }
  }

  // checkValidation() {
  //   let validateFlag = true;
  //   if (this.userModal.emailAddress.trim().length === 0 || this.inValidEmail) {
  //     validateFlag = false;
  //   }
  //   if (this.userModal.firstName.trim().length === 0) {
  //     validateFlag = false;
  //   }
  //   if (this.userModal.lastName.trim().length === 0) {
  //     validateFlag = false;
  //   }
  //   return validateFlag;
  // }

  // onKeyUp() {
  //   this.onMetadataKeyUp();
  // }

  // metatUrlValid() {
  //   return (
  //     this.metadataURL.match(this.urlValidator) &&
  //     this.metadataURL !== '' &&
  //     this.clientID !== '' &&
  //     this.clientSecret !== ''
  //   );
  // }

  enableOnlyMetadataURL() {
    this.disableMetadataURL = false;
    this.disableOIDC = true;
    this.disableOIDCAuthType = true;
    this.disableSAML = true;
  }

  enableControlsOnMetadataURLAccess() {
    this.disableMetadataURL = false;
    this.disableOIDC = false;
    this.disableOIDCAuthType = true;
    this.disableSAML = true;
  }

  disableControlsOnMetadataURLAccess() {
    this.disableMetadataURL = true;
    this.disableSAML = false;
    this.disableOIDC = false;
    this.disableOIDCAuthType = false;
  }

  accessToMetadataToggle() {
    this.accessToMetadata
      ? this.enableControlsOnMetadataURLAccess()
      : this.disableControlsOnMetadataURLAccess();
  }

  accessToMedataCheck() {
    this.accessToMetadata
      ? this.enableControlsOnMetadataURLAccess()
      : this.disableControlsOnMetadataURLAccess();
  }

  onMetadataURLFocus() {
    this.metadataURLResponseMessage = '';
  }

  openDetails() {
    this.showIdpDetailDialog = true;
  }

  changeAuthorizationType(authorizationType: any) {
    this.authorizationType = `${authorizationType
      .charAt(0)
      .toUpperCase()}${authorizationType.slice(1)}`;
    this.disableOIDCAuthType = true;
    // if(this.authorizationType === 'Code') {

    // }

    // const oidcGroup = this.idpFormGroupAlt.controls['protocolGroup'].controls['oidcGroup'].controls['authTypeGroup'].controls
    // Object.values(oidcGroup)
    // .forEach((element: any) => {
    //   element.disable();
    // });
    // this.authorizationType === 'Code' ? oidcGroup['codeGroup'].enable() : oidcGroup['tokenGroup'].enable();
  }

  disableProtocolGroup() {
    this.disableMetadataURL = true;
    this.disableSAML = true;
    this.disableOIDC = true;
    this.disableOIDCAuthType = true;
  }

  enableProtocolGroup() {
    this.disableMetadataURL = false;
    this.disableSAML = false;
    this.disableOIDC = false;
    this.disableOIDCAuthType = false;
  }

  changeProtocol(protocol: any = '') {
    console.warn(protocol);
    this.protocol = protocol;
    this.disableProtocolGroup();
    // protocol === 'SAML' ? protocolGroup['samlGroup'].enable() : protocolGroup['oidcGroup'].enable();
    if (protocol === 'SAML') {
      this.disableSAML = false;
      //   protocolGroup['samlGroup'].enable();
    } else {
      //   protocolGroup['oidcGroup'].enable();
      this.disableOIDC = false;
      this.disableOIDCAuthType = false;
      this.changeAuthorizationType('Code');
      // this.onClientSecretIdKeyUp();
      this.showPWentry()
    }
  }

  showPWentry() {
    this.$nextTick(() => {
      if ((this.$refs['clientSecretRef'] as SwTextfield)) {
        // tslint:disable-next-line
        (this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.setAttribute('style', 'cursor: pointer');
        // tslint:disable-next-line
        (this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.addEventListener('click', () => {
           // tslint:disable-next-line
          (this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'text');
        });
        // tslint:disable-next-line
        (this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByClassName('sw-textfield__wrapper')[0]?.querySelector('.sw-icon')?.addEventListener('mouseout', () => {
           // tslint:disable-next-line
          (this.$refs['clientSecretRef'] as SwTextfield)?.$el?.getElementsByTagName('input')[0]?.setAttribute('type', 'password');
        });
      }
    });
  }

  populateSSOURL(ssourl: any) {
    this.ssoURL = ssourl;
  }

  populate_x509Certificate(x509: any) {
    this.x509Certificate = x509;
  }

  changeClientIDandClientSecret(clientID: any, clientSecret: any) {
    this.clientID = clientID;
    this.clientSecret = clientSecret;
  }

  chooseMode(mode: any, testParams?: any) {
    console.warn(mode);
    switch (mode) {
      case 'handshake': {
        this.spinnerInline = true;
        const params = {
          metadataURL: this.accessToMetadata ? this.metadataURL : '',
          mode: 'HANDSHAKE',
          clientID: this.clientID,
          secretKey: this.clientSecret,
        };
        this.$store.dispatch('SnbProfileStoreModule/metadataExchange', params).then(
          (resp: any) => {
            if (resp.operationStatus === 'NOK') {
              this.metadataURLResponseMessage = resp.msgDesc;
            }
            const idp = resp?.idp;
            try {
              this.chooseIDP(idp.idpOrganization);
              this.changeProtocol(idp.protocol);
              this.populateSSOURL(idp.ssoURL);
              this.populate_x509Certificate(idp.x509certificate);
              this.changeAuthorizationType(idp.responseType);

              if (idp.authorization_endpoint) {
                this.populateAuthorizationEndpoint(idp.authorization_endpoint);
              } else {
                this.populateIntrospectionEndpoint(idp.introspection_endpoint);
              }
            } catch (e) {
              console.warn(e);
            }
            this.disableProtocolGroup();
            this.disableMetadataURL = false;
            this.spinnerInline = false;
            this.$store.commit('stopLoading');
          },
          (error) => {
            this.spinnerInline = false;
            console.warn(error);
          },
        );
        break;
      }
      case 'test': {
        this.spinner = true;
        this.$store.dispatch('SnbProfileStoreModule/metadataExchange', testParams).then(
          (resp: any) => {
            this.$store.commit('stopLoading');
            this.spinner = false;
            if (resp.msgCode === 'MSWAPP:SUCCESS') {
              const message: InfoState = { infoMsg: resp.msgDesc, infoType: 'success' };
              this.$store.commit('enqueueMessage', message);
              this.$emit('testCondition', false);
              this.disableProtocolGroup();
              this.testorsaveConnection(true);
            } else {
              const message: InfoState = { infoMsg: resp.msgDesc, infoType: 'failed' };
              this.$store.commit('enqueueMessage', message);
              this.accessToMedataCheck();
            }
          },
          (error) => {
            this.spinner = false;
            console.warn(error);
          },
        );
        break;
      }
      case 'register': {
        this.spinner = true;
        this.enableProtocolGroup();
        this.$store.dispatch('SnbProfileStoreModule/metadataExchange', testParams).then(
          (resp: any) => {
            this.$store.commit('stopLoading');
            this.spinner = false;
            if (resp.msgCode === 'MSWAPP:SUCCESS') {
              const message: InfoState = { infoMsg: resp.msgDesc, infoType: 'success' };
              this.$store.commit('enqueueMessage', message);
            } else {
              const message: InfoState = { infoMsg: resp.msgDesc, infoType: 'failed' };
              this.$store.commit('enqueueMessage', message);
            }
            this.$emit('closeIdpConfigDialog');
          },
          (error) => {
            this.spinner = false;
            console.warn(error);
          },
        );
        break;
      }
      case 'editRegistry': {
        const params = {
          mode: '',
        };
        this.$store.dispatch('SnbProfileStoreModule/metadataExchange', params).then(
          (resp: any) => {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'NOK') {
              this.metadataURLResponseMessage = resp.msgDesc;
            } else {
              const idp = resp.idp;
              try {
                const isOkta = idp.metadataURL.toString().indexOf('okta.com') > -1;
                isOkta ? this.chooseIDP('OKTA') : this.chooseIDP('AZURE');
                this.changeProtocol(idp.protocol);
                this.populateSSOURL(idp.ssoURL);
                this.populate_x509Certificate(idp.x509certificate);
                this.changeAuthorizationType(idp.responseType);
                this.changeClientIDandClientSecret(idp.clientID, idp.secretKey);
                if (idp.protocol === 'OIDC') {
                  this.populateAuthorizationEndpoint(idp.authorization_endpoint);
                } else {
                  if (idp.token_endpoint) {
                    this.populateAuthorizationEndpoint(idp.token_endpoint);
                  } else {
                    this.populateIntrospectionEndpoint(idp.introspection_endpoint);
                  }
                }
                this.allEmployees = idp.appliedToAllUsers === 'YES' ? true : false;
                if (idp.showApplytoAll === 'YES') {
                  this.showEmpIdpToggle = true;
                } else if (idp.showApplytoAll === 'NO') {
                  this.showEmpIdpToggle = false;
                }
                if (this.allEmployees) {
                  this.disableAllEmployeeToggle = true;
                } else if (!this.allEmployees) {
                  this.disableAllEmployeeToggle = false;
                }
              } catch (e) {
                console.warn(e);
              }
            }
            this.disableProtocolGroup();
            this.spinnerInline = false;
            this.accessToMedataCheck();
          },
          (error) => {
            this.spinnerInline = false;
            console.warn(error);
          },
        );
        break;
      }
    }
  }

  populateAuthorizationEndpoint(authorizationEndpoint: any) {
    this.authURL = authorizationEndpoint;
    this.introURL = '';
  }

  populateIntrospectionEndpoint(intorspectionEndpoint: any) {
    this.introURL = intorspectionEndpoint;
    this.authURL = '';
  }

  chooseIDP(value: any) {
    this.idpOrganization = value.toUpperCase();
    value.toUpperCase() === 'OKTA'
      ? (this.imgURL = this.oktaImgURL)
      : (this.imgURL = this.azureImgURL);
    value.toUpperCase() === 'OKTA'
      ? (this.helpURLReference = this.oktaHelpURL)
      : (this.helpURLReference = this.azureHelpURL);
    this.imageSrc = this.imgURL;
    this.metadataURLText = `I have access to ${this.idpOrganization} Metadata URL`;
  }

  //   adjustTextArea($event : any) {
  //     const textarea = $event.target;
  //     textarea.style.height = 'auto';
  //     textarea.style.height = `${textarea.scrollHeight}px`;
  //   }

  changeIDP() {
    this.$emit('closeIdpConfigDetailDialog');
  }

  validateOIDC() {
    if (
      (this.authURL.match(this.urlValidator) && this.clientID && this.clientSecret) ||
      (this.introURL.match(this.urlValidator) && this.clientID && this.clientSecret)
    ) {
      return true;
    } else {
      return false;
    }
  }

  validateSAML() {
    if (this.ssoURL.match(this.urlValidator) && this.ssoURL && this.x509Certificate) {
      return true;
    } else {
      return false;
    }
  }

  testorsaveConnection(save: boolean) {
    console.warn('ailoo');
    console.warn(this.validateSAML());
    this.isSubmitted = true;
    this.enableProtocolGroup();

    if (this.validateSAML()) {
      this.clientandsecretOn = true;
      const params = {
        metadataURL: this.accessToMetadata ? this.metadataURL : '',
        mode: save ? 'REGISTER' : 'HANDSHAKE',
        idpOrganization: this.idpOrganization,
        protocol: 'SAML',
        ssoURL: this.ssoURL,
        x509Certificate: this.x509Certificate,
        applytoAllEmployees: this.allEmployees ? 'YES' : 'NO',
      };
      save ? this.chooseMode('register', params) : this.chooseMode('test', params);
    } else if (this.validateOIDC()) {
      console.warn('OIDC');
      this.clientandsecretOn = false;
      const params = {
        metadataURL: this.accessToMetadata ? this.metadataURL : '',
        mode: save ? 'REGISTER' : 'HANDSHAKE',
        idpOrganization: this.idpOrganization,
        protocol: 'OIDC',
        introspectionURL: this.introURL,
        authorizationURL: this.authURL,
        clientID: this.clientID,
        secretKey: this.clientSecret,
        applytoAllEmployees: this.allEmployees ? 'YES' : 'NO',
        responseType: this.authorizationType,
      };
      save ? this.chooseMode('register', params) : this.chooseMode('test', params);
    }
  }
}
